/**
 * Problemsignale eines Projekts als kleine Badges hinter dem Projektnamen: Symbol und Anzahl – Wecker für überfällige Termine, Ausrufezeichen für
 * Probleme –, die Erklärung im Tooltip. Bekommt die fertigen Badges.
 */
import React from "react";
import { Box, Tooltip } from "@mui/material";
import { PriorityHigh as ProblemIcon } from "@mui/icons-material";
import { URGENCY_ICON } from "../../../common/display/DeadlineCell";
import { SignalBadge } from "../../../../utils/projectFocus";
import { colors } from "../../../../styles/colors";

interface ProjectSignalBadgesProps {
  badges: SignalBadge[];
}

const ICONS = { overdue: URGENCY_ICON.overdue, problem: ProblemIcon };

const ProjectSignalBadges: React.FC<ProjectSignalBadgesProps> = ({
  badges,
}) => {
  if (badges.length === 0) return null;
  return (
    <Box sx={{ display: "inline-flex", gap: 0.5, flexShrink: 0 }}>
      {badges.map((badge) => {
        const Icon = ICONS[badge.kind];
        return (
          <Tooltip key={badge.tooltip} title={badge.tooltip}>
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.25,
                px: 0.5,
                height: 20,
                borderRadius: 1,
                fontSize: "0.75rem",
                fontWeight: 600,
                color: colors.status.error.main,
                backgroundColor: colors.status.error.background,
              }}
            >
              <Icon sx={{ fontSize: 14 }} />
              {badge.count}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default ProjectSignalBadges;
